import { Link } from "react-router-dom";
import "./feature-card-style.scss";

//寬版主打卡
//
//  跟 ProductCard 的差別：那個是直式小卡（卡片列用），這個是寬版大卡，
//  封面佔滿整張、文案壓在下緣 —— 用在「即時熱門」這種一次只推幾個的區塊。
//
//  右下角的圓鈕是「前往」不是「播放」：我們沒有影片內容，
//  用播放鍵會讓人以為點了會播東西。
const FeatureCard = ({ item }) => {
  const { glyph, theme = "ink", title, subtitle, image, path } = item;

  return (
    <Link to={path || "#"} className="fc">
      <div
        className={`fc__cover fc__cover--${theme}`}
        style={image ? { backgroundImage: `url(${image})` } : undefined}
      >
        {/* 沒有圖時才顯示大字，有圖就讓圖自己說話 */}
        {!image && <span className="fc__glyph">{glyph}</span>}
      </div>

      <div className="fc__info">
        <div className="fc__text">
          <h3 className="fc__title">{title}</h3>
          {subtitle && <p className="fc__subtitle">{subtitle}</p>}
        </div>

        <span className="fc__go" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>
    </Link>
  );
};

export default FeatureCard;
